import { render, staticRenderFns } from "./AuthSecond.vue?vue&type=template&id=d98a326e&scoped=true&"
import script from "./AuthSecond.vue?vue&type=script&lang=ts&"
export * from "./AuthSecond.vue?vue&type=script&lang=ts&"
import style0 from "./AuthSecond.vue?vue&type=style&index=0&id=d98a326e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98a326e",
  null
  
)

export default component.exports